import React from "react";
import StarryNightSky from "./Stars";
import infosecdata from "../utils/data/INFOSEC.json";

const Vendors = () => {
  return (
    <>
      <section className="bg-black text-white w-screen relative">
        <StarryNightSky height="250vh" />
        {infosecdata.USERROLES.map((roleGroup, groupIndex) => {
          // Find all cards for this role group
          const headingCard = roleGroup.cards.find(card => card.heading);
          const imageCard = roleGroup.cards.find(card => card.img);
          const noHeadingCards = roleGroup.cards.filter(card => card.noheading);

          // Collect all description items from all cards for mobile
          const allDescItems = [];
          
          // Add description items from heading card
          if (headingCard && headingCard.desc) {
            allDescItems.push(...headingCard.desc);
          }
          
          // Add description items from image card
          if (imageCard && imageCard.desc) {
            allDescItems.push(...imageCard.desc);
          }
          
          // Add description items from no heading cards
          noHeadingCards.forEach(card => {
            if (card.desc) {
              allDescItems.push(...card.desc);
            }
          });

          return (
            <div key={groupIndex} className="mx-auto flex flex-col pt-[50px] gap-3 lg:w-[1200px]">
              
              {/* Mobile Layout */}
              <div className="block md:hidden">
                {/* Heading Section - Mobile */}
                {headingCard && (
                  <div className="flex flex-col items-center text-center p-7">
                    <div className="flex flex-col gap-3 max-w-[600px]">
                      <h1
                        className="font-black text-[24px] leading-[160%] tracking-[0em] capitalize bg-clip-text text-transparent"
                        style={{
                          backgroundImage: "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
                        }}
                      >
                        {headingCard.heading}
                      </h1>
                      <p className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize">
                        {headingCard.title}
                      </p>
                    </div>
                  </div>
                )}

                {/* Image Section - Mobile */}
                {imageCard && (
                  <div className="flex justify-center items-center p-7">
                    <div className="w-full max-w-[400px] flex justify-center">
                      <img 
                        src={imageCard.img} 
                        alt="Illustration" 
                        className="w-auto h-auto max-w-full max-h-[350px] object-contain"
                      />
                    </div>
                  </div>
                )}

                {/* All Description Items - Mobile */}
                {allDescItems.length > 0 && (
                  <div className="flex justify-center p-7">
                    <div className="w-full max-w-[800px]">
                      <ul className="flex flex-col gap-3">
                        {allDescItems.map((descItem, i) => (
                          <li
                            key={i}
                            className="animated-border-box flex gap-3 rounded-[8px] p-3 bg-white/5 backdrop-blur-[300px] mb-2 relative overflow-hidden"
                          >
                            <img src="/Cone.png" alt="•" className="w-5 h-5 flex-shrink-0 mt-1" />
                            <span className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize">
                              {descItem}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* Desktop Layout - Keep Original */}
              <div className="hidden md:block">
                {/* Main Heading Section */}
                {headingCard && (
                  <div className="flex flex-col md:flex-row items-center md:gap-[88px] p-7">
                    <div className="flex flex-col gap-3 lg:max-w-[330px]">
                      <h1
                        className="font-black text-[16px] leading-[160%] tracking-[0em] capitalize bg-clip-text text-transparent md:text-[40px]"
                        style={{
                          backgroundImage: "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
                        }}
                      >
                        {headingCard.heading}
                      </h1>
                      <p className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize md:text-lg">
                        {headingCard.title}
                      </p>
                    </div>
                    <div className="w-6/12 xl:w-full">
                      <ul className="flex flex-col gap-3">
                        {headingCard.desc.map((descItem, i) => (
                          <li
                            key={i}
                            className="animated-border-box flex gap-3 rounded-[8px] p-3 bg-white/5 backdrop-blur-[300px] mb-2 relative overflow-hidden"
                          >
                            <img src="/Cone.png" alt="•" className="w-5 h-5" />
                            <span className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize">
                              {descItem}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {/* Image Section - Desktop */}
                {imageCard && (
                  <div className="flex flex-col md:flex-row items-center md:gap-[88px] p-7">
                    {/* Content (shown first on desktop) */}
                    <div className="w-full md:max-w-[600px] xl:w-auto order-2 md:order-1">
                      <ul className="flex flex-col gap-3">
                        {imageCard.desc.map((descItem, i) => (
                          <li
                            key={i}
                            className="animated-border-box flex gap-3 rounded-[8px] p-3 bg-white/5 backdrop-blur-[300px] mb-2 relative overflow-hidden"
                          >
                            <img src="/Cone.png" alt="•" className="w-5 h-5" />
                            <span className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize">
                              {descItem}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Desktop Image (shown on right) */}
                    <div className="hidden md:flex md:justify-center md:items-center md:w-[350px] md:h-[350px] order-3">
                      <img 
                        src={imageCard.img} 
                        alt="Illustration" 
                        className="w-auto h-auto max-w-full max-h-full object-contain"
                      />
                    </div>
                  </div>
                )}

                {/* Additional Content Sections - Desktop */}
                {noHeadingCards.map((card, cardIndex) => (
                  <div key={cardIndex} className="flex flex-col md:flex-row items-center md:gap-[88px] p-7">
                    <div className="hidden  md:block w-[400px]"></div>
                    <div className="md:w-5/12 xl:w-full">
                      <ul className="flex flex-col gap-3">
                        {card.desc.map((descItem, i) => (
                          <li
                            key={i}
                            className=" animated-border-box flex gap-3 rounded-[8px] p-3 bg-white/5 backdrop-blur-[300px] mb-2 relative overflow-hidden"
                          >
                            
                            <img src="/Cone.png" alt="•" className="w-5 h-5" />
                            <span className="font-medium text-[16px] leading-[160%] tracking-[0em] capitalize">
                              {descItem}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>

              <div className="w-10/12 border-[1px] border-[#49454F] mt-12 mx-auto"></div>
            </div>
          );
        })}
      </section>
    </>
  );
};

export default Vendors;